module.exports = __webpack_public_path__ + "img/que-bottom.d7d7f151.png";